import React from 'react';
import {useField} from 'formik';

const SelectControl = ({ label, ...props }) => {
  const errorStyle = {
    color: 'red'
  };
    // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
    // which we can spread on <input> and alse replace ErrorMessage entirely.
    const [field, meta] = useField(props);
    return (

      <div class="form-floating mb-1">
        <select {...field} {...props} />
        <label htmlFor={props.id || props.name}>{label}</label>
        {meta.touched && meta.error ? (
          <div style={errorStyle} className="error">{meta.error}</div>
        ) : null}        
        </div>
    );
  };

  export default SelectControl;